import {
  USER_PROJECT_LIST_FAIL,
  USER_PROJECT_LIST_REQUEST,
  USER_PROJECT_LIST_SUCCESS,
  USER_PROJECT_TIME_LIST_FAIL,
  USER_PROJECT_TIME_LIST_REQUEST,
  USER_PROJECT_TIME_LIST_SUCCESS,
  USER_PROJECT_ADD_TIME_IN_LIST_FAIL,
  USER_PROJECT_ADD_TIME_IN_LIST_REQUEST,
  USER_PROJECT_ADD_TIME_IN_LIST_SUCCESS,
  USER_ADD_WEB_PROJECT_LIST_FAIL,
  USER_ADD_WEB_PROJECT_LIST_REQUEST,
  USER_ADD_WEB_PROJECT_LIST_SUCCESS,
  USER_PROJECT_EDIT_TIME_IN_LIST_FAIL,
  USER_PROJECT_EDIT_TIME_IN_LIST_REQUEST,
  USER_PROJECT_EDIT_TIME_IN_LIST_SUCCESS,
  USER_ALL_REPORT_DATA_LIST_FAIL,
  USER_ALL_REPORT_DATA_LIST_REQUEST,
  USER_ALL_REPORT_DATA_LIST_SUCCESS,
  USER_ALL_USER_CHECKIN_LIST_FAIL,
  USER_ALL_USER_CHECKIN_LIST_REQUEST,
  USER_ALL_USER_CHECKIN_LIST_SUCCESS,
  USER_PROJECT_DELETE_IN_LIST_FAIL,
  USER_PROJECT_DELETE_IN_LIST_REQUEST,
  USER_PROJECT_DELETE_IN_LIST_SUCCESS,
  USER_PROJECT_DELETE_TIME_IN_LIST_FAIL,
  USER_PROJECT_DELETE_TIME_IN_LIST_REQUEST,
  USER_PROJECT_DELETE_TIME_IN_LIST_SUCCESS,
} from "../../types/user/projectTypes";

export const userProjectReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_PROJECT_LIST_REQUEST:
      return {
        ...state,
        projectLoading: true,
      };
    case USER_PROJECT_LIST_SUCCESS:
      return {
        ...state,
        projectLoading: false,
        UserProjectInfo: payload,
        projectError: "",
      };
    case USER_PROJECT_LIST_FAIL:
      return {
        ...state,
        projectLoading: false,
        UserProjectInfo: [],
        projectError: payload,
      };
    default:
      return state;
  }
};

export const userProjectTimeDateReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_PROJECT_TIME_LIST_REQUEST:
      return {
        ...state,
        projectTimeLoading: true,
      };
    case USER_PROJECT_TIME_LIST_SUCCESS:
      return {
        ...state,
        projectTimeLoading: false,
        UserProjectTimeInfo: payload,
        projectTimeError: "",
      };
    case USER_PROJECT_TIME_LIST_FAIL:
      return {
        ...state,
        projectTimeLoading: false,
        UserProjectTimeInfo: [],
        projectTimeError: payload,
      };
    default:
      return state;
  }
};

export const userProjectAddTimeReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_PROJECT_ADD_TIME_IN_LIST_REQUEST:
      return {
        ...state,
        projectAddTimeLoading: true,
      };
    case USER_PROJECT_ADD_TIME_IN_LIST_SUCCESS:
      return {
        ...state,
        projectAddTimeLoading: false,
        projectAddTimeInfo: payload,
        projectAddTimeError: "",
      };
    case USER_PROJECT_ADD_TIME_IN_LIST_FAIL:
      return {
        ...state,
        projectAddTimeLoading: false,
        projectAddTimeInfo: [],
        projectAddTimeError: payload,
      };
    default:
      return state;
  }
};

export const userAddWebProjectReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_ADD_WEB_PROJECT_LIST_REQUEST:
      return {
        ...state,
        webprojectAddLoading: true,
      };
    case USER_ADD_WEB_PROJECT_LIST_SUCCESS:
      return {
        ...state,
        webprojectAddLoading: false,
        webprojectAddInfo: payload,
        webprojectAddError: "",
      };
    case USER_ADD_WEB_PROJECT_LIST_FAIL:
      return {
        ...state,
        webprojectAddLoading: false,
        webprojectAddInfo: [],
        webprojectAddError: payload,
      };
    default:
      return state;
  }
};

export const userEditProjectTimeReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_PROJECT_EDIT_TIME_IN_LIST_REQUEST:
      return {
        ...state,
        projectEditTimeLoading: true,
      };
    case USER_PROJECT_EDIT_TIME_IN_LIST_SUCCESS:
      return {
        ...state,
        projectEditTimeLoading: false,
        projectEditTimeInfo: payload,
        projectEditTimeError: "",
      };
    case USER_PROJECT_EDIT_TIME_IN_LIST_FAIL:
      return {
        ...state,
        projectEditTimeLoading: false,
        projectEditTimeInfo: [],
        projectEditTimeError: payload,
      };
    default:
      return state;
  }
};

export const userAllReportDataReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_ALL_REPORT_DATA_LIST_REQUEST:
      return {
        ...state,
        userAllReportLoading: true,
      };
    case USER_ALL_REPORT_DATA_LIST_SUCCESS:
      return {
        ...state,
        userAllReportLoading: false,
        userAllReportInfo: payload,
        userAllReportError: "",
      };
    case USER_ALL_REPORT_DATA_LIST_FAIL:
      return {
        ...state,
        userAllReportLoading: false,
        userAllReportInfo: [],
        userAllReportError: payload,
      };
    default:
      return state;
  }
};

export const userAllUserStatusReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_ALL_USER_CHECKIN_LIST_REQUEST:
      return {
        ...state,
        AllUserStatusLoading: true,
      };
    case USER_ALL_USER_CHECKIN_LIST_SUCCESS:
      return {
        ...state,
        AllUserStatusLoading: false,
        AllUserStatusInfo: payload,
        AllUserStatusError: "",
      };
    case USER_ALL_USER_CHECKIN_LIST_FAIL:
      return {
        ...state,
        AllUserStatusLoading: false,
        AllUserStatusInfo: [],
        AllUserStatusError: payload,
      };
    default:
      return state;
  }
};

export const deleteProjectReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_PROJECT_DELETE_IN_LIST_REQUEST:
      return {
        ...state,
        projectDelLoading: true,
      };
    case USER_PROJECT_DELETE_IN_LIST_SUCCESS:
      return {
        ...state,
        projectDelLoading: false,
        UserProjectDelInfo: payload,
        projectDelError: "",
      };
    case USER_PROJECT_DELETE_IN_LIST_FAIL:
      return {
        ...state,
        projectDelLoading: false,
        UserProjectDelInfo: [],
        projectDelError: payload,
      };
    default:
      return state;
  }
};

export const deleteProjectTimeReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_PROJECT_DELETE_TIME_IN_LIST_REQUEST:
      return {
        ...state,
        proTimeDelLoading: true,
      };
    case USER_PROJECT_DELETE_TIME_IN_LIST_SUCCESS:
      return {
        ...state,
        proTimeDelLoading: false,
        UserproTimeDelInfo: payload,
        proTimeDelError: "",
      };
    case USER_PROJECT_DELETE_TIME_IN_LIST_FAIL:
      return {
        ...state,
        proTimeDelLoading: false,
        UserproTimeDelInfo: [],
        proTimeDelError: payload,
      };
    default:
      return state;
  }
};
